import React from "react";
import "./CdPortal.css";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";

const CdPortal = () => {
  /* feburary 16th 2024 at 8am */
  const ourDate = new Date("2025-02-16T08:00:00");
  return <div className="cd-portal"></div>;
};

export default CdPortal;
